import { GridModel, GridParams, GridPostParams } from "common/models/utility-models/list-utility.model";
import { InternshipFilterModel, } from "../Intership Filter Form/internship-list-filter-data.model";


export class InternshipListGridModel extends  InternshipFilterModel{}

export class InternshipListListingModel extends GridModel<InternshipListGridModel> { 
    filterData: any;
}

export class InternshipListGridParams extends GridPostParams {
    // pageNumber: 1;
    // pageSize: 10;
    // searchText: '';
    // direction: '';
    // column: ''
    studentInternshipStatus: number = 0;
    year: number = 2024;
    // id: any =400;
    // countFlag: any =1;
}

export class InternshipStudentListGridParams extends GridParams{
    year: string;
    studentInternshipStatus: number ;
}
